import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Hero from './components/Hero';
import FeaturedComics from './components/FeaturedComics';
import CategoryGrid from './components/CategoryGrid';
import NewUpdates from './components/NewUpdates';
import FAQSection from './components/FAQSection';
import { getHomepageSchema } from './schema';

const BASE_URL = 'https://hanman.com';

export default function Home() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);

  const schema = getHomepageSchema();

  return (
    <>
      <SEO
        title="免费韩漫大全_好看的韩国漫画_漫画韩漫网址_韩漫在线观看-韩漫网"
        description="韩漫网利用漫画网址实现免费韩漫大全与好看韩国漫画的韩漫在线观看，覆盖恋爱、奇幻、动作、搞笑、悬疑、BL、GL等全部分类，每日更新，功能全面满足您的需求。"
        keywords="免费韩漫大全,好看韩国漫画,漫画网址,韩漫在线观看,韩漫网"
        canonicalUrl={BASE_URL}
        ogImage={`${BASE_URL}/og-image.jpg`}
        schema={{
          ...schema.organization,
          ...schema.website,
          ...schema.webpage,
          ...schema.breadcrumb,
        }}
      />

      <Navbar />
      <main>
        <article>
          <Hero />
        </article>
        <FeaturedComics />
        <CategoryGrid />
        <NewUpdates />
        <FAQSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema.itemList) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema.categoryList) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema.faq) }}
      />
    </>
  );
}